const mapToUrlType = {
  1: 'systemic',
  2: 'marketing',
  3: 'others',
};

export const urlAdapter = (url) => {
  return {
    name: url.title,
    type: mapToUrlType[url.type],
    createdAt: url.created_at,
    clickNumber: url.total_clicks,
    tinyUrl: url.default_short_url,
    userId: url.user_id,
  };
};
